import { useTranslation } from 'react-i18next';

import { PracticeLogo } from './practice-logo.js';
import { LanguageSwitcher } from '../i18n-module/language-switcher.js';
import { useTenantConfig } from '../tenant-config-module/use-tenant-config.js';

/**
 * Kompakter Top-Bar für das Lovable-Layout:
 *  - links: 24-px-Brand-Glyph (`object-contain`) + Praxis-Name als kleiner,
 *    leicht zurückgenommener Text;
 *  - rechts: DE/EN-Pill-Toggle (`LanguageSwitcher`).
 *
 * Konsumiert `useTenantConfig()` — funktioniert daher sowohl im echten Stack
 * (TenantConfig aus dem Backend) als auch im Mock-Mode, sobald `<MockApp>`
 * einen TenantConfigContext bereitgestellt hat.
 *
 * Anzeigename: `config.tenantName` ist optional. Fehlt das Feld (z. B. bei
 * älteren Tenant-Configs ohne Lovable-Refresh), fällt der Header auf den
 * i18n-Default `appointment.heading` zurück.
 */
export function TenantHeader(): JSX.Element {
  const { t } = useTranslation();
  const config = useTenantConfig();
  const headerLabel = config.tenantName ?? t('appointment.heading');
  return (
    <header className="flex items-center justify-between gap-4 px-6 pt-6 pb-2">
      <div className="flex items-center gap-2">
        <PracticeLogo src={config.logoUrl} alt={t('app.logoAlt')} sizeClassName="h-8 w-8" />
        <span className="text-sm font-medium text-foreground/80">{headerLabel}</span>
      </div>
      <LanguageSwitcher />
    </header>
  );
}
